// @ts-nocheck
/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { IconWrapper } from "@insite/mobius/Icon";
import MobiusLink, { LinkPresentationProps } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import Flash from "@store/Library/Components/Icons/Flash";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import * as React from "react";
import { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const isAuthenticated = getSession(state).isAuthenticated;

    return {
        url: getPageLinkByPageType(state, "QuickOrderPage")?.url,
        hasViewOnlyRole: isAuthenticated && getSession(state).userRoles.includes("ViewOnly"),
        isAuthenticated,
    };
};

export interface QuickOrderLinkStyles {
    link?: LinkPresentationProps;
}

export const quickOrderLinkStyles: QuickOrderLinkStyles = {
    link: {
        css: css`
            display: block;

            &:hover {
                ${IconWrapper} {
                    color: ${getColor("primary")};
                }
            }
        `,
        icon: {
            iconProps: {
                color: "icon",
                size: 30,
                src: Flash,
                css: css`
                    vertical-align: middle;
                    margin-right: ${pxToRem(5)};
                `,
            },
        },
    },
};

const styles = quickOrderLinkStyles;

type Props = ReturnType<typeof mapStateToProps>;

export const QuickOrderLink: FC<Props> = ({ url, hasViewOnlyRole, isAuthenticated }) => {
    if (!isAuthenticated) {
        return null;
    }

    if (!url) {
        return null;
    }

    if (hasViewOnlyRole) {
        return null;
    }

    return (
        <MobiusLink {...styles.link} href={url} icon={{ iconProps: { ...styles.link?.icon?.iconProps } }}>
            {translate("Quick Order")}
        </MobiusLink>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(QuickOrderLink),
    definition: {
        group: "Basic",
        icon: "Link",
        fieldDefinitions: [],
    },
};

export default widgetModule;
